import { withParams } from 'vuelidate';
export default (divisor) =>
	withParams({ type: 'divisibleByNumber', divisor }, function (value) {
		if (typeof value === 'undefined' || value === null || value === '') {
			return true;
		}
		return !(value % divisor);
	});
